export const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://kill-snap.jeremy.ninja';
export const IMAGE_CDN_URL = process.env.REACT_APP_IMAGE_CDN_URL || '';
